import React from 'react';

import SetoCanvasPage from 'pages/SetoCanvasPage';

class _401 extends React.Component {

	render() {
		return (
				<SetoCanvasPage id="_401Page" title="Your session has expired | Seto Canvas">
					<h1 style={{textAlign: "center", color: "gray"}}>Your session has expired. Please login again.</h1>
				</SetoCanvasPage>
			);
		
	}
}


export default _401;


// WEBPACK FOOTER //
// ./src/pages/401.js